/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StarIcon24Solid = forwardRef('StarIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.967 1.8c.39-.908 1.676-.908 2.066 0l2.53 5.875 6.37.59c.984.092 1.381 1.315.64 1.966l-4.807 4.222 1.407 6.241c.217.963-.823 1.719-1.672 1.215L12 18.643l-5.5 3.266c-.85.504-1.89-.252-1.673-1.215l1.407-6.24-4.806-4.223c-.742-.651-.345-1.874.638-1.965l6.37-.591 2.53-5.876Z" })));
});
